import React from "react";
import { Link,useParams } from "react-router-dom";
import Footer from "../components/footer/Footer";
import Title from "../components/misc/Title";
import NavBar from "../components/navigation/NavBar";
import DelyCard from "../components/card/DelyCard";

import shawarma from "../data/shawarma";

const ShawarmaItem = () => {
  let { categoryId } = useParams();
  let menuData = shawarma[categoryId];
  return (
    <>
      <NavBar />
      <main>
        <div id="swipe-up-indicator">Swipe Up</div>
        <Title withButton={true} title={menuData.type} />
        <hr />
        <DelyCard menu={menuData.menu} clickableTag={true}/>
        <div className="vege-btn-c">
          <Link to="/vegetarian">View All Vegetarian Food</Link>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ShawarmaItem;
